<template>
  <system
    class="system system--debug"
    @touchmove="processTouchMove"
    @touchdown="processEvent"
    @mousedown="mouseDown"
    @mouseup="mouseUp"
    @mousemove="processEvent"
    :style="`top:${y}px; left:${x}px`"
  >
    <br>
    <div>
      <button @click.stop="testArEndSession">testArEndSessi 111zz</button>
    </div>
  </system>
</template>
<script>
import { mapMutations } from 'vuex';
import { mutationTypes, actionTypes } from '../types';
import { uiComponents } from '../tools/viewState';
import errorHandler from '../tools/errorHandler';

export default {
	data() {
		return {
			drag: false,
			x: 100,
			y: 100,
			dragStartX: 0,
			dragStartY: 0,
		};
	},
	methods: {
		...mapMutations([mutationTypes.toggleInViewState]),
		createError() {
			errorHandler(new Error('unkownCode'));
		},

		processTouchMove(event) {
			event.preventDefault();
			event.stopPropagation();
			event.returnValue = false;
			// const rect = event.target.getBoundingClientRect();
			// const x = event.targetTouches[0].clientX - rect.left; // x position within the element.
			// const y = event.targetTouches[0].clientY - rect.top; // y position within the element.
		},
		mouseDown() {
			event.preventDefault();
			event.stopPropagation();
			const rect = event.target.getBoundingClientRect();
			this.dragStartX = event.clientX - rect.left; // x position within the element.
			this.dragStartY = event.clientY - rect.top; // y position within the element.
			this.drag = true;
		},
		mouseUp() {
			event.preventDefault();
			event.stopPropagation();
			this.drag = false;
		},
		processEvent(event) {
			event.preventDefault();
			event.stopPropagation();

			if (this.drag) {
				event.returnValue = false;
				// const rect = event.target.getBoundingClientRect();
				// const x = event.clientX - rect.left; // x position within the element.
				// const y = event.clientY - rect.top; // y position within the element.
				this.x = event.clientX - this.dragStartX;
				this.y = event.clientY - this.dragStartY;
			}
		},
		openGlossary() {
			console.log('Opene Glossary');
			this.$store.dispatch(actionTypes.searchShowGlossary);
		},
		testArEndSession() {
			window.nativeOnAREndSession({
				PlayingMediaObjects: {
					id: '5c5c49f898b2db176dd0f574',
					type: 'audio',
					I18nContent: [
						{
							languageISO: '',
							title: '01 Aquila',
							description: 'Die Weltallritter',
							source:
								'https://web.cms.shoutrlabs.com/5a71f1e159bad07c933f2b8d//apps/media-5c8a48bc2bd59a6ee0200633/5c800434cb127f2ad796638e.mp3',
							duration: 226.7760009765625,
						},
					],
					position: 121.95529174804688,
				},
				ActivatedVUMarkIDs: [1],
			});
		},
	},
	created() {
		this.uiComponents = Object.values(uiComponents);
		this.errorHandler = errorHandler;
	},
};
</script>
<style>
.system--debug {
	background-color: coral;
	z-index: 9999999999;
	position: fixed;
	top: 0px;
	width: 200px;
	height: 300px;
}
</style>
